(function () {
  var CLICK_IDS = ["gclid", "fbclid"];        // matches PERSISTED_CLICK_IDS
  var FIRST_TOUCH = ["landing_url", "landing_referrer"];
  var PREFIX = "ht_";                          // matches CLICK_ID_COOKIE_PREFIX
  var COOKIE_DAYS = 90;                        // matches CLICK_ID_COOKIE_DAYS

  function setCookie(name, value, days) {
    // SameSite=Lax survives same-site navigation; no Secure so it also works on
    // http during local dev; path=/ makes it readable across the whole site.
    var maxAge = days * 24 * 60 * 60;
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + maxAge + "; SameSite=Lax";
  }

  function getCookie(name) {
    var match = document.cookie.split("; ").find(function (c) {
      return c.indexOf(name + "=") === 0;
    });
    return match ? decodeURIComponent(match.slice(name.length + 1)) : "";
  }

  function deleteCookie(name) {
    document.cookie = name + "=; path=/; max-age=0; SameSite=Lax";
  }

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key) || ""; } catch (e) { return ""; }
  }

  // "yes" -> true, "no" -> false, "" / missing / no API -> undefined (undecided).
  function marketingConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== "function") return undefined;
      var raw = cp.currentVisitorConsent() || {};
      return raw.marketing === "yes" ? true : raw.marketing === "no" ? false : undefined;
    } catch (e) {
      return undefined;
    }
  }

  // 1) First-touch â€” capture the first page + referrer of this visit into
  //    sessionStorage immediately, write-once, ungated. Internal navigation on
  //    later pages hits the guard and leaves the earliest values untouched.
  try {
    var ss = window.sessionStorage;
    if (ss && !ss.getItem(PREFIX + "landing_url")) {
      // Store the FULL href / referrer verbatim, query string included â€” so any
      // utm_* or other campaign params on the entry page ride along inside
      // landing_url / landing_referrer. Never strip the query string here.
      ss.setItem(PREFIX + "landing_url", window.location.href);
      ss.setItem(PREFIX + "landing_referrer", document.referrer || "");
    }
  } catch (e) { /* sessionStorage blocked (private mode) â€” skip first-touch */ }

  // 2) Click-ids present in THIS page's URL -> pending consent-gated cookie writes.
  var q = new URLSearchParams(window.location.search);
  var pendingClickIds = [];
  CLICK_IDS.forEach(function (key) {
    var value = q.get(key);
    if (value && value.trim()) pendingClickIds.push([PREFIX + key, value.trim()]);
  });

  function applyConsent() {
    var marketing = marketingConsent();
    if (marketing === true) {
      pendingClickIds.forEach(function (p) { setCookie(p[0], p[1], COOKIE_DAYS); });
      // Promote first-touch to a cross-session cookie. Write-once: only when not
      // already cookied, so the earliest visit's landing page/referrer wins.
      FIRST_TOUCH.forEach(function (key) {
        var name = PREFIX + key;
        if (!getCookie(name)) {
          var value = sessionGet(name);
          if (value) setCookie(name, value, COOKIE_DAYS);
        }
      });
    } else if (marketing === false) {
      // Explicit denial â€” clear anything persisted on an earlier consented visit.
      CLICK_IDS.forEach(function (key) { deleteCookie(PREFIX + key); });
      FIRST_TOUCH.forEach(function (key) { deleteCookie(PREFIX + key); });
    }
    // undefined (undecided / no CMP) â€” leave cookies untouched, wait for a decision.
  }

  // Act on the current decision now, and again whenever the banner updates it.
  applyConsent();
  document.addEventListener("visitorConsentCollected", applyConsent);
})();